import styled from 'styled-components';

export const JobDescriptionField = styled.div`
  margin-bottom: 25px;

  h3 {
    font-family: Helvetica !important;
    font-size: 18px;
    font-weight: 700;
    line-height: 20.7px;
    margin: 0;
    text-align: left;
  }

  p {
    font-family: Helvetica !important;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-top: 13px;
  }
`;
